<i18n>
{
  "de": {
    "search": "Suche",
    "subscriptions": "Mitgliedschaften",
    "products": "Produkte",
    "filterByOffers": "Angebote"
  },
  "en": {
    "search": "Search",
    "subscriptions": "Memberships",
    "products": "Products",
    "filterByOffers": "Offers"
  }
}
</i18n>

<template>
  <section v-if="artist && rewardOptions.length">
    <vue-multi-select
      ref="rewardMultiSelect"
      v-model="values"
      class="multi-select filter-reward"
      :class="{
        'filter-reward-mobile': layout === 'mobileFilterPosts',
        'has-selections': hasSelections
      }"
      :options="options"
      :filters="filters"
      :btnLabel="btnLabel"
      :position="layout === 'mobileFilterPosts' ? '' : 'bottom-left'"
      :searchPlaceholder="`${$t('search')}...`"
      :selectOptions="rewardOptions"
      @selectionChanged="executeFilter"
      @open="onDropdownOpen"
    />
  </section>
</template>

<script>
import { mapState } from 'vuex'
import vueMultiSelect from 'vue-multi-select'
import 'vue-multi-select/dist/lib/vue-multi-select.css'

export default {
  props: ['layout', 'clear'],
  components: { vueMultiSelect },
  name: 'Filter-Posts-Reward',
  data: () => ({
    values: [],
    filters: [],
    options: {
      multi: true,
      groups: true,
      labelValue: '_id',
      cssSelected: (option) => option.selected ? { 'font-weight': 'bold', color: '#fb3e52' } : ''
    },
    filterInitialized: false
  }),
  watch: {
    clear: {
      handler(oldVal, newVal) {
        if (newVal === true) {
          this.values = []
        }
      }
    }
  },
  computed: {
    hasSelections() {
      return this.values && this.values.length > 0
    },
    rewardOptions() {
      if (!this.artist) return []
      const options = []
      if (this.rewards.length) {
        options.push({
          name: this.$t('subscriptions'),
          list: this.rewards
        })
      }
      if (this.singleRewards.length) {
        options.push({
          name: this.$t('products'),
          list: this.singleRewards
        })
      }
      return options
    },
    singleRewards() {
      if (!this.artist) return []
      return this.artist.products.map(p => {
        return {
          _id: p._id,
          name: p.name,
          type: 'product'
        }
      })
    },
    rewards() {
      if (!this.artist) return []
      return this.artist.rewards.map(r => {
        return {
          _id: r._id,
          name: r.name,
          type: 'reward'
        }
      })
    },
    ...mapState(['artist', 'postFilter'])
  },
  methods: {
    btnLabel() {
      return this.$t('filterByOffers') + (this.values.length ? ` (${this.values.length})` : '')
    },

    clearResult() {
      this.value = []
    },

    resetFilterUI() {
      this.values = []
      this.filterInitialized = false
    },

    initFilter() {
      for (const productFilter of this.postFilter.product) {
        const product = this.artist.products.find(p => p._id === productFilter)
        if (product) {
          this.values.push({
            _id: product._id,
            name: product.name,
            type: 'product'
          })
        }
      }
      for (const rewardFilter of this.postFilter.reward) {
        const reward = this.artist.rewards.find(r => r._id === rewardFilter)
        if (reward) {
          this.values.push({
            _id: reward._id,
            name: reward.name,
            type: 'reward'
          })
        }
      }
    },

    restoreFilter() {
      this.filterInitialized = false
      this.values = []

      if (
        !this.postFilter ||
        (!this.postFilter.reward && !this.postFilter.product) ||
        (!this.postFilter.reward.length && !this.postFilter.product.length)
      ) {
        return this.clearResult()
      }

      for (const productFilter of this.postFilter.product) {
        const product = this.artist.products.find(p => p._id === productFilter)
        if (product) {
          this.values.push({
            _id: product._id,
            name: product.name,
            type: 'product'
          })
        }
      }

      for (const rewardFilter of this.postFilter.reward) {
        const reward = this.artist.rewards.find(r => r._id === rewardFilter)
        if (reward) {
          this.values.push({
            _id: reward._id,
            name: reward.name,
            type: 'reward'
          })
        }
      }
      this.filterInitialized = true
    },

    onDropdownOpen() {
      this.$root.$emit('closeOtherFilterDropdowns', 'rewards')
    },

    closeDropdown() {
      this.$refs.rewardMultiSelect?.closeMultiSelect?.()
    },

    async executeFilter() {
      if (!this.filterInitialized) {
        this.filterInitialized = true
        return
      }

      const filter = { product: [], reward: [] }
      for (const purchasable of this.values) {
        filter[purchasable.type].push(purchasable._id)
      }

      this.$emit('filter', filter)
    }
  },

  mounted() {
    if (this.artist) {
      this.initFilter()
    }

    this.$root.$on('recoverPostFilter', this.restoreFilter)
    this.$root.$on('resetAllFilters', this.resetFilterUI)
    this.$root.$on('closeOtherFilterDropdowns', (openedBy) => {
      if (openedBy !== 'rewards') {
        this.closeDropdown()
      }
    })
    this.filterInitialized = true
  },

  beforeDestroy() {
    this.$root.$off('recoverPostFilter', this.restoreFilter)
    this.$root.$off('resetAllFilters', this.resetFilterUI)
    this.$root.$off('closeOtherFilterDropdowns')
  }
}
</script>
